<template >

<div>
<div class="panal mt-20">
<div class="panal-header">Address </div>

<div class="table-responsive p-3">
<table class="table table-hover table-bordered">
  <thead class="thead-light">
    <tr>
      <th scope="col" width="20%">Country</th>
      <th scope="col" width="20%">City</th>
      <th scope="col" width="40%">Address</th>
      <th scope="col" width="20%">ISPrimary</th>
    </tr>
  </thead>
  <tbody>
            <tr v-if="EmptyAddress"> <td colspan="4"> No Data  </td></tr>

    <tr v-else v-for="address in AdressList" v-bind:key="address.serial">
        
          <td >{{address.CountryNameEN}}</td>
          <td>{{address.GovernorateNameEN}}</td>
          <td>{{address.Address}}</td>
          <td v-if="address.IsPrimary" @click="handleSetPrimary(address.serial , 1)"><font-awesome-icon icon="user" class="text-success"/></td>
          <td v-if="!address.IsPrimary" @click="handleSetPrimary(address.serial , 1)"><i class="glyphicon glyphicon-ok-sign text-success"></i></td>
          
        </tr>
    
    <tr class="table-borderless">
            <td  align="left">
            <span class="text-left">Country</span>
               <select class="form-control w-100 su-border"  v-model="ApplicantAdress.CountrySerial" @change="handelGovernrate"  v-b-tooltip.hover title="Country">
                 <option value="0" selected>choose</option>
              <option v-for="country in Countries" :value="country.Serial" v-bind:key="country.Serial" >{{country.CountryNameEN}}</option>
            
            </select>
  
            </td>
            <td align="left">
            <span>Governorate</span>
               <select class="form-control w-100 su-border" v-model="ApplicantAdress.GovernerateSerial" v-b-tooltip.hover title="Governorate">
              <option v-for="country in GovernrateList" :value="country.Serial" v-bind:key="country.Serial" >{{country.GovernorateNameEN}}</option>
            </select>
            </td>
            <td align="left">
            <span>Address</span>
              <input type="text" class="form-control" v-model="ApplicantAdress.Address" v-b-tooltip.hover title="Address" />
            </td>
           <td colspan="5" style="text-align: left;">
           <br/>
                <button type="button" class="btn btn-block btn-primary btn-sm" id="addrow"  @click="handleAdress()" :disabled="loading && Flag==3">
                       <span v-show="loading && Flag==3" class="spinner-border spinner-border-sm"></span>
                      Add Address</button> 
            </td>
        </tr>
  </tbody>
</table>

   <div v-if="message && Flag==3" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>

</div>



</div>


<div class="panal mt-20" >
<div class="panal-header">Email </div>

<div class="table-responsive p-3">
<table class="table table-hover table-bordered" :key="!update">
  <thead class="thead-light">
    <tr>
      <th scope="col" width="35%">Email</th>
      <th scope="col" width="15%">IsPrimary</th>
    </tr>
  </thead>
  <tbody>
                <tr v-if="emptyEmail && Flag == 2"> <td colspan="4"> No Data  </td></tr>

    <tr v-else v-for="Phone in EmailList" v-bind:key="Phone.serial">
        
          <td>{{Phone.ContactDetails}}</td>
          <td v-if="Phone.IsPrimary" @click="handleSetPrimary(Phone.serial , 2)"><font-awesome-icon icon="user" class="text-success" /></td>
          <td v-if="!Phone.IsPrimary" @click="handleSetPrimary(Phone.serial , 2)"><i class="glyphicon glyphicon-ok-sign text-success"></i></td>
        </tr>
    
    <tr class="table-borderless"> 
            <td  align="left" >
            <span class="text-left">Email</span>
    
       
        <input type="email" v-validate="'email|max:50'" name="email" class="form-control su-border"  v-b-tooltip.hover title="Add new email"  placeholder="Add New Mail" v-model="ApplicantEmail.ContactDetails">
      
            <div v-if="submitted && Flag==2 && errors.has('email')" class="alert-danger">{{errors.first('email')}}</div>
            </td>
   
          
           <td  style="text-align: left;">
           <br/>
         <button type="button" class="btn btn-block btn-primary btn-sm mt-1" id="addrow"  @click="handleEmail()" :disabled="loading && Flag == 2">
                       <span v-show="loading && Flag==2" class="spinner-border spinner-border-sm"></span>
                      Add Email</button>            </td>
        </tr>
  </tbody>
</table>

    <div v-if="message && Flag==2" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>

</div>



</div>


<div class="panal mt-20">
  <div class="panal-header">Phone </div>

    <div class="table-responsive p-3 ">
    <table class="table table-hover table-bordered">
      <thead class="thead-light">
        <tr>
          <th scope="col" >PHONE</th>
          <th scope="col">IS PRIMARY	</th>
        </tr>
      </thead>
      <tbody>
                    <tr v-if="emptyPhone"> <td colspan="4"> No Data  </td></tr>

        <tr v-else v-for="Phone in phoneList" v-bind:key="Phone.serial">
        
          <td>{{Phone.ContactDetails}}</td>
          <td v-if="Phone.IsPrimary" @click="handleSetPrimary(Phone.serial , 3)"><font-awesome-icon icon="user" class="text-success"/></td>
          <td v-if="!Phone.IsPrimary" @click="handleSetPrimary(Phone.serial , 3)"><i class="glyphicon glyphicon-ok-sign text-success" ></i></td>
        </tr>
        
        <tr class="table-borderless">
                <td  align="left" >
                <span class="text-left">Phone</span>
        
          
            <input type="phone" v-validate="'numeric|min:3|max:20'" name="phone" class="form-control su-border"  v-b-tooltip.hover title="Add new phone " placeholder="Add new phone " v-model="ApplicantPhone.ContactDetails">
                      <div v-if="submitted && Flag == 1 && errors.has('phone')" class="alert-danger">{{errors.first('phone')}}</div>

      
                </td>
      
               
              <td  style="text-align: left;">
              <br/>
                    <button type="button" class="btn btn-block btn-primary btn-sm mt-1" id="addrow"  @click="handlePhone()" :disabled="loading && Flag == 1">
                       <span v-show="loading && Flag==1" class="spinner-border spinner-border-sm"></span>
                      Add Phone</button>
                </td>
          
            </tr>
      </tbody>
    </table>

   <div v-if="message && Flag==1" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>

  </div>



</div>



</div>

</template>

<script>
import {ApplicantContact , Countries,Governrates ,ApplicantAdress, SetPrimary} from "../../models/Applicant";
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services';
import ApplicantServices from "../../services/Applicant/Applicant.service";
export default {
        name: 'Contact',
        data(){
          return{
          ApplicantPhone : new ApplicantContact('',5,'',''),
          ApplicantEmail : new ApplicantContact('',2,'',''),
           Countries: new Countries('','','','','','',''),
           ApplicantAdress : new ApplicantAdress('',0,0,''),
           GovernrateList:new Governrates('',0,'','',''),
           SetPrimary : new SetPrimary ('','','',''),
          ApplicantID: '',
          phoneList :[],
          EmailList:[],
          AdressList:[],
            isPrimary : false ,
             message: '',
            submitted:false,
            loading: false,
            successful: false,
            Flag:'',
            update:false,
            emptyPhone:false,
            emptyEmail:false,
            EmptyAddress:false
          }
        },
        computed:{
          currenUser(){
            return  this.$store.state.auth.user
          },
          reviewApplication(){
           return  this.$store.state.auth.renderReview 
           }
        },
        mounted(){
          this.ApplicantID = this.currenUser.UserIDSerial
        this.ApplicantPhone.ApplicantID = this.ApplicantID
        this.ApplicantEmail.ApplicantID = this.ApplicantID
        ApplicantDataServices.GetApplicantEmailAndPhone(this.ApplicantPhone).then(Response =>{
          this.phoneList=Response.data
        }, error => {
              
                  // eslint-disable-next-line no-console
                  console.log(error.response.status)
                  this.emptyPhone = true
               
              this.successful =false
              this.Flag =1
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            });
            
        ApplicantDataServices.GetApplicantEmailAndPhone(this.ApplicantEmail).then(Response =>{
          this.EmailList=Response.data
                         

        }, error => {

                   this.emptyEmail = true
                  this.Flag =2
                 
              this.successful =false
              this.Flag =2
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                if(error.response.status == 404) this.message =''
            });
            
        ApplicantDataServices.GetAddressOfApplicants(this.ApplicantID).then(Response =>{
          this.AdressList=Response.data
        }, error => {
         
                   this.EmptyAddress = true
                  this.Flag =3

              this.successful =false
              this.Flag =3
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
         if(error.response.status == 404) this.message =''

            });
        
        ApplicantServices.GetCountriesSelectAll().then(Response =>{
          this.Countries=Response.data
        }, error => {
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });
        
        },
        methods:{
          handlePhone() {
         
          this.message = '';
          this.submitted = true;
          this.Flag = 1 ;
          if(this.ApplicantPhone.ContactDetails == null || this.ApplicantPhone.ContactDetails == ""){
            this.message = "please enter your phone "
            this.successful = false
            return
          }
           this.$validator.validate().then(isValid => {
          if (isValid) {
          this.loading= true;
          this.ApplicantPhone.ApplicantID =  this.ApplicantID
          this.ApplicantPhone.IsPrimary = this.isPrimary
            ApplicantDataServices.PostApplicantEmailAndPhone(this.ApplicantPhone).then(Res => {
               
              
                this.message = Res.data;
                this.successful = true;
                this.loading = false;
                this.submitted =false
            this.$store.dispatch('auth/Review', this.reviewApplication+1 )
              
                ApplicantDataServices.GetApplicantEmailAndPhone(this.ApplicantPhone).then(Response =>{
                        this.phoneList=Response.data
                     this.emptyPhone =false
                })
                }, error => {
               this.message =
               (error.response && error.response.data && error.response.data.Message) ||
                 error.message ||  
                   error.toString();
               this.successful = false;
               this.loading = false;
               this.submitted = false
              })
          
          }
          })
        
          },
          handleEmail() {
           
          this.message = '';
          this.submitted = true;
          this.Flag = 2;
           if(this.ApplicantEmail.ContactDetails == null || this.ApplicantEmail.ContactDetails == ""){
            this.message = "please enter your email "
            this.successful = false
            return
          }
         this.$validator.validate().then(isValid => {
          if (isValid) {
            this.loading= true;
           this.ApplicantEmail.ApplicantID =  this.ApplicantID
          this.ApplicantEmail.IsPrimary = this.isPrimary
          
            ApplicantDataServices.PostApplicantEmailAndPhone(this.ApplicantEmail).then(
              Res => {
                          this.$store.dispatch('auth/Review', this.reviewApplication+1 )

                this.message = Res.data;
                this.successful = true;
                this.loading = false;
                this.submitted =false
                    ApplicantDataServices.GetApplicantEmailAndPhone(this.ApplicantEmail).then(Response =>{
                     this.EmailList=Response.data
                     this.emptyEmail =false;    

                  })
                },
              error => {
               this.message =
               (error.response && error.response.data && error.response.data.Message) ||
                 error.message ||  
                   error.toString();
               this.successful = false;
               this.loading = false;
               this.submitted =false
              })
          }})
          },
          handelGovernrate(){
            ApplicantServices.GetGovernorate(this.ApplicantAdress.CountrySerial).then( data => {
                 this.GovernrateList= data.data 
                  this.message = ""
                // eslint-disable-next-line no-unused-vars
                }).catch(Response=>{
                //if(Response.response.status == 400){
                  this.GovernrateList =('',0,'','','')
                  this.Flag = 3
                  this.message = "No Governarate for this Country"
                  this.successful = false;
                  this.loading = false;
            
                } 
                
               
                ),
              error => {
               this.GovernrateList =('',0,'','','')
               this.message =
               (error.response && error.response.data && error.response.data.Message) ||
                 error.message ||  
                   error.toString();
               
              }
          },
          handleAdress(){
            this.Flag = 3
            this.ApplicantAdress.ApplicantID = this.ApplicantID;
              ApplicantDataServices.PostApplicantAddressInsert(this.ApplicantAdress).then(
              data => {
                ApplicantDataServices.GetAddressOfApplicants(this.ApplicantID).then(Response =>{
                   this.AdressList=Response.data
                               this.$store.dispatch('auth/Review', this.reviewApplication+1 )

                   this.EmptyAddress = false
                  })
                this.ApplicantAdress=('',0,0,'')
                this.message = data.data;
                this.successful = true;
                this.loading = false;
                               this.submitted =false

                }),
              error => {
               this.message =
               (error.response && error.response.data && error.response.data.Message) ||
                 error.message ||  
                   error.toString();
               this.successful = false;
               this.loading = false;
                              this.submitted =false

              } 
          },
          handleSetPrimary(Serial , typeid){

              this.SetPrimary.ApplicantID = this.currenUser.UserIDSerial
              this.SetPrimary.RowSerial = Serial 
              this.SetPrimary.FlagContacttype = typeid 
              this.SetPrimary.Primary = true
              ApplicantDataServices.SetPrimary(this.SetPrimary).then(Response =>{
                this.$store.dispatch('auth/Review', this.reviewApplication+1 )
             this.update=false
             this.message = Response.data
             this.successful =true
                if (typeid == 1){
                    this.Flag = 3
                    this.AdressList  =  this.AdressList.map(x=> {
                        if (x.serial == Serial) {x.IsPrimary=true} else {x.IsPrimary = false}
                      return x
                    }) 
                   // eslint-disable-next-line no-console 
                   console.log('newlsit',this.AdressList)
                   }           
                  else if (typeid == 3)
                 {
                   this.Flag = 1
                 this.phoneList  =  this.phoneList.map(x=> {
                        if (x.serial == Serial) {x.IsPrimary=true} else {x.IsPrimary = false}
                      return x
                    }) 
                 }else{
                   this.Flag = typeid
                   this.EmailList  =  this.EmailList.map(x=> {
                        if (x.serial == Serial) {x.IsPrimary=true} else {x.IsPrimary = false}
                      return x
                    }) 
                 }         
            
              
        })
          
           
          }
          
        }
    }
</script>

<style scoped>

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
    border: 1px solid #d4d4d4;
padding:0px 0px 20px 0px;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.mt-20{
  margin-top:20px;
}
.mt-40{
  margin-top:40px;
}

th{
font-weight:bold;
}
.su-border {
    border-color: #3D8FE3 !important;
    background: #F1F9FF !important;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

</style> 